import { TicketSectionId } from 'views/WorkQueue/WorkQueue.types';

import { Section } from 'components/Ticket/TicketsContainers/TicketsContainers.constants';

export const sectionNameToSectionIdMap: Record<Section, TicketSectionId> = {
  [Section.Assigned]: TicketSectionId.AssignedToMe,
  [Section.Urgent]: TicketSectionId.UrgentPatientReports,
  [Section.NonUrgent]: TicketSectionId.OtherPatientReports,
  [Section.TasksDue]: TicketSectionId.TasksDue,
  [Section.Overdue]: TicketSectionId.OverdueReports,
  [Section.Callback]: TicketSectionId.TicketsAndCallbackRequests,
  [Section.ResolvedItems]: TicketSectionId.ResolvedItems
};
